import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-342">
      <div className="max-w-5xl mx-auto" data-id="element-343">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-344">
          <div data-id="element-345">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-346">
              +300
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-347">
              profes confían
            </div>
          </div>
          <div data-id="element-348">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-349">
              6+6
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-350">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-351">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-352">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-353">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-354">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-355">🇦🇷</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-356">
              Todo el país
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-357">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-358">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-359">
              MR
            </div>
            <div data-id="element-360">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-361">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-362">
                "Organicé todo el año en una tarde. Ahora tengo cada clase
                pensada y secuenciada para todos mis grupos."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-363">
                — María Rosa, Buenos Aires | Profesora de Pádel en Club de
                Barrio
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-364">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-365">
              JC
            </div>
            <div data-id="element-366">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-367">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-368">
                "Las 40 clases por nivel con progresión real. Mis alumnos
                avanzan de categoría por primera vez."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-369">
                — Jorge C., Rosario | Instructor de Pádel en Academia Privada
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-370">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-371">
              SV
            </div>
            <div data-id="element-372">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-373">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-374">
                "Adapto el mismo drill a 4 niveles distintos en 5 minutos. Antes
                me llevaba horas inventar."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-375">
                — Sofía V., Córdoba | Profesora de Pádel Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}